import HttpRequest from './httpRequest'

export default class FeedbackProvider extends HttpRequest {
  createFeedback(attributes) {
    return this.create('/feedback', attributes)
  }
}
